import styled from 'styled-components';

export const SectionItems = styled.div`
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  display: flex;
  flex-direction: row;
`;

export const SectionHeading = styled.h2`
  color: ${Styles.color.grey.one};
  font-family: ${Styles.fontFamily.base};
  margin: 0 0 0.625rem 0;
  text-transform: uppercase;
`;

export const SectionItemContainer = styled.div`
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;
